import { render } from "./AuthLogin.vue?vue&type=template&id=782b852e"
import script from "./AuthLogin.vue?vue&type=script&lang=ts"
export * from "./AuthLogin.vue?vue&type=script&lang=ts"
script.render = render

export default script